import React from "react";
import ReactDOM from "react-dom";
import "./services/i18n/i18n";
import "normalize.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppProvider } from "./context/appContext";

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
